import { render, staticRenderFns } from "./myPersonholiday.vue?vue&type=template&id=6a9dd14c&scoped=true&"
import script from "./myPersonholiday.vue?vue&type=script&lang=js&"
export * from "./myPersonholiday.vue?vue&type=script&lang=js&"
import style0 from "./myPersonholiday.vue?vue&type=style&index=0&id=6a9dd14c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9dd14c",
  null
  
)

export default component.exports